import { CONTRACTOR_LOCATIONS_CRUD_ACTION_CREATORS } from '../actions/contractor_locations_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';

export const contractorLocationsRestCrudThunksForBuyer = new RestCrudThunks(
	'contractor_locations',
	'contractor_location',
	'contractorLocation',
	'contractorLocations',
	CONTRACTOR_LOCATIONS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'location/'
);
export const contractorLocationsRestCrudThunksForSupplier = new RestCrudThunks(
	'contractor_locations',
	'contractor_location',
	'contractorLocation',
	'contractorLocations',
	CONTRACTOR_LOCATIONS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'location/'
);
